import React from "react"
import Layout from "../../layout"
import { Link, graphql } from "gatsby"
import ReactPlayer from "react-player"

import { ButtonLink } from "../../atoms/buttons"
import { Grid } from "../../atoms/grid"
import { Box } from "../../atoms/box"

import { withLightbox } from "../../molecules/lightbox"
import {
  PartnerDescription,
  PartnerText,
  PartnerNoDescription,
} from "../../molecules/partners"
import { Flatcard } from "../../molecules/card"
import Carousel from "../../molecules/carousel"

import { Banner } from "../../organisms/banner"
import {
  ImageGallery,
  VideoGallery,
  SevenGallery,
} from "../../organisms/gallery"
import {
  Paired,
  Numbered,
  PairedRepeat,
  PairedDoubleRepeat,
  ImageWithLink,
  ThreeColumns,
} from "../../organisms/patterns"
import { Break, Tab } from "../../organisms/breaks"
import { Downloads } from "../../organisms/downloads"
import { LogoDescription } from "../../organisms/partners"
import { Statistics } from "../../organisms/statistics"
import { MediaReleasesList } from "../../organisms/mediaReleases"
import { NewsbyteList } from "../../organisms/newsbyte"
import { ExhibitorsNewsroom } from "../../organisms/exhibitorsNewsroom"
import { FormCluster } from "../../organisms/forms"
import { Quotes } from "../../organisms/quotes"
import { Team, TeamFlexi } from "../../organisms/team"
import { Map } from "../../organisms/map"
import { StaticDisplays } from "../../organisms/staticDisplays"
import { Advertisement } from "../../organisms/advertisement"

import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import styled from "styled-components"
import { Settings } from "../../../styles/theme"
import Img from "gatsby-image"
import SEO from "../../seo"

//Pull Data
import {
  BookABoothContact,
  Subscribe,
  SalesEnquiry,
  SubscribePublic,
} from "../../forms/index"
import { FullCard, FullCardWithPopup } from "../../atoms/card"
import Texture from "../../../images/icons/texture.png"

const pageTemplate = ({ data }) => (
  <Layout>
    <SEO />
    {data.contentfulPage.content
      ? data.contentfulPage.content.map((obj, i) => {
          switch (obj.__typename) {
            case "ContentfulMedia":
              return <ContentfulMedia object={obj} key={i} />
            case "ContentfulContent":
              return <ContentfulContent object={obj} key={i} />
            case "ContentfulPattern":
              return <EnhancedContentfulPattern object={obj} key={i} />
            case "ContentfulSpecials":
              return <ContentfulSpecials object={obj} key={i} />
            case "ContentfulBreaks":
              return (
                <ContentfulBreaks
                  object={obj}
                  key={i}
                  slug={data.contentfulPage.slug}
                />
              )
            case "ContentfulTabGroup":
              return <ContentfulTab object={obj} key={i} />
            default:
              return console.log(obj)
          }
        })
      : ""}
  </Layout>
)

const Tabtemplate = ({ data }) => {
  return data.content.map((obj, i) => {
    switch (obj.__typename) {
      case "ContentfulMedia":
        return <ContentfulMedia object={obj} key={i} />
      case "ContentfulContent":
        return <ContentfulContent object={obj} key={i} />
      case "ContentfulPattern":
        return <EnhancedContentfulPattern object={obj} key={i} />
      case "ContentfulSpecials":
        return <ContentfulSpecials object={obj} key={i} />
      case "ContentfulBreaks":
        return <ContentfulBreaks object={obj} key={i} slug={data.slug} />
      case "ContentfulTabGroup":
        return <ContentfulTab object={obj} key={i} />
      default:
        return console.log(obj)
    }
  })
}

const Tabstyle = styled.div`
  position: relative;
  padding: 1rem 0;
  .tab {
    display: none;
  }
  .tab.active {
    display: block;
  }
  .tabNav {
    border-bottom: 3px solid ${Settings.secondaryColor};
    > div {
      @media screen and (max-width: ${Settings.sizeM}) {
        display: none;
      }
      > div {
        text-align: center;
        h4 {
          font-size: 1.2rem;
          margin-bottom: 1rem;
          cursor: pointer;
        }
        h4.selected {
          font-weight: 700;
          color: ${Settings.secondaryColor};
        }
      }
    }
  }
  .mobileNav {
    display: none;
    .nav {
      position: relative;
    }
    .nav {
      h4,
      b {
        display: inline-block;
        margin: 1rem 0;
      }
    }
    b {
      font-size: 2rem;
      color: ${Settings.secondaryColor};
      float: right;
    }
    @media screen and (max-width: ${Settings.sizeM}) {
      display: block;
      h4 {
        color: ${Settings.secondaryColor};
        font-weight: 700;
        font-size: 1.5rem;
      }
    }
    .dropdown {
      display: none;
      position: absolute;
      top: 5rem;
      left: 50%;
      background: #fff;
      width: 100%;
      box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.5);
      z-index: 100;
      width: 90%;
      transform: translateX(-50%);
      h4 {
        margin: 2rem;
      }
    }
    .dropdown.show {
      display: block;
    }
  }
`

const Navistyle = styled.div`
  position: relative;
  padding: 1rem 0;
  > div {
    > div {
      align-items: stretch;
    }
  }
  .tab {
    display: none;
  }
  .tab.active {
    display: block;
  }
  .tabNav {
    border-right: 3px solid ${Settings.secondaryColor};
    flex: 1 1 5%;
    @media screen and (max-width: ${Settings.sizeM}) {
      display: none;
    }
    > div {
      text-align: right;
      h4 {
        font-size: 1.5rem;
        margin-bottom: 1rem;
        cursor: pointer;
      }
      h4.selected {
        font-weight: 700;
        color: ${Settings.secondaryColor};
      }
    }
  }
  .mobileNav {
    display: none;
    border-bottom: 2px solid ${Settings.secondaryColor};
    .nav {
      position: relative;
    }
    .nav {
      h4,
      b {
        display: inline-block;
        margin: 1rem 0;
      }
    }
    b {
      font-size: 2rem;
      color: ${Settings.secondaryColor};
      float: right;
    }
    @media screen and (max-width: ${Settings.sizeM}) {
      display: block;
      h4 {
        color: ${Settings.secondaryColor};
        font-weight: 700;
        font-size: 1.5rem;
      }
    }
    .dropdown {
      display: none;
      position: absolute;
      top: 5rem;
      left: 50%;
      background: #fff;
      width: 100%;
      box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.5);
      z-index: 100;
      width: 90%;
      transform: translateX(-50%);
      h4 {
        margin: 2rem;
      }
    }
    .dropdown.show {
      display: block;
    }
  }
`

const ContentTab = ({
  object,
  selected,
  setSelected,
  toggle,
  toggleLightbox,
}) => {
  switch (object.types) {
    case "Tab":
      return (
        <Tabstyle>
          <div className="constraint mobileNav">
            <div className="nav" onClick={() => toggleLightbox()}>
              <h4>{object.tabs[selected].title}</h4>
              <b>⌄</b>
            </div>
            <div className={toggle ? "dropdown show" : "dropdown"}>
              {object.tabs.map((tab, i) => (
                <div>
                  <h4
                    key={i}
                    onClick={() => {
                      setSelected(i)
                      toggleLightbox()
                    }}
                    className={selected === i ? "selected" : ""}
                  >
                    {tab.title}
                  </h4>
                </div>
              ))}
            </div>
          </div>
          <div className="constraint tabNav">
            <Carousel slide={5} nodot>
              {object.tabs.map((tab, i) => (
                <div>
                  <h4
                    key={i}
                    onClick={() => setSelected(i)}
                    className={selected === i ? "selected" : ""}
                  >
                    {tab.title}
                  </h4>
                </div>
              ))}
            </Carousel>
          </div>
          <div>
            {object.tabs.map((tab, i) => (
              <div className={i === selected ? "active tab" : "tab"}>
                <Tabtemplate data={tab} key={i} />
              </div>
            ))}
          </div>
        </Tabstyle>
      )
    case "Navigation":
      return (
        <Navistyle>
          <div className="constraint mobileNav">
            <div className="nav" onClick={() => toggleLightbox()}>
              <h4>{object.tabs[selected].title}</h4>
              <b>⌄</b>
            </div>
            <div className={toggle ? "dropdown show" : "dropdown"}>
              {object.tabs.map((tab, i) => (
                <div>
                  <h4
                    key={i}
                    onClick={() => {
                      setSelected(i)
                      toggleLightbox()
                    }}
                    className={selected === i ? "selected" : ""}
                  >
                    {tab.title}
                  </h4>
                </div>
              ))}
            </div>
          </div>
          <div className="constraint">
            <Grid unstack>
              <div className="tabNav">
                {object.tabs.map((tab, i) => (
                  <div>
                    <h4
                      key={i}
                      onClick={() => setSelected(i)}
                      className={selected === i ? "selected" : ""}
                      style={{ paddingRight: "1rem" }}
                    >
                      {tab.title}
                    </h4>
                  </div>
                ))}
              </div>
              <div style={{ flex: "1 1 80%" }}>
                {object.tabs.map((tab, i) => (
                  <div className={i === selected ? "active tab" : "tab"}>
                    <Tabtemplate data={tab} key={i} />
                  </div>
                ))}
              </div>
            </Grid>
          </div>
        </Navistyle>
      )
    default:
      return (
        <Tabstyle>
          <div className="constraint mobileNav">
            <div className="nav" onClick={() => toggleLightbox()}>
              <h4>{object.tabs[selected].title}</h4>
              <b>⌄</b>
            </div>
            <div className={toggle ? "dropdown show" : "dropdown"}>
              {object.tabs.map((tab, i) => (
                <div>
                  <h4
                    key={i}
                    onClick={() => {
                      setSelected(i)
                      toggleLightbox()
                    }}
                    className={selected === i ? "selected" : ""}
                  >
                    {tab.title}
                  </h4>
                </div>
              ))}
            </div>
          </div>
          <div className="constraint tabNav">
            <Carousel slide={5} nodot>
              {object.tabs.map((tab, i) => (
                <div>
                  <h4
                    key={i}
                    onClick={() => setSelected(i)}
                    className={selected === i ? "selected" : ""}
                  >
                    {tab.title}
                  </h4>
                </div>
              ))}
            </Carousel>
          </div>
          <div>
            {object.tabs.map((tab, i) => (
              <div className={i === selected ? "active tab" : "tab"}>
                <Tabtemplate data={tab} key={i} />
              </div>
            ))}
          </div>
        </Tabstyle>
      )
  }
}

const ContentfulTab = withLightbox(ContentTab)

const ContentfulSpecials = ({ object }) => {
  switch (object.type) {
    case "Static Displays":
      return <StaticDisplays />
    case "Downloads":
      return <Downloads object={object} />
    case "Media Releases":
      return <MediaReleasesList />
    case "Exhibitors Newsroom":
      return <ExhibitorsNewsroom />
    case "Newsbytes":
      return <NewsbyteList />
    case "Book a Booth Form":
      return <FormCluster data={BookABoothContact} />
    case "Team":
      return <Team />
    case "Map":
      return <Map />
    case "Statistics":
      return (
        <div className="constraint" style={{ maxWidth: "740px" }}>
          <Statistics />
        </div>
      )
    case "Subscribe Form":
      return (
        <div>
          <div className="constraint">
            <h4 style={{ fontWeight: "700", opacity: "0.4" }}>
              <h1>SUBSCRIBE TO SINGAPORE AIRSHOW 2020 NEWS</h1>
            </h4>
          </div>
          <FormCluster data={Subscribe} />
        </div>
      )
    case "Subscribe Form Public":
      return (
        <div>
          <div className="constraint">
            <h4 style={{ fontWeight: "700", opacity: "0.4" }}>
              <h1>SUBSCRIBE TO MAILING LIST</h1>
            </h4>
          </div>
          <FormCluster data={SubscribePublic} />
        </div>
      )
    case "Sales Form":
      return (
        <div>
          <div className="constraint">
            <h4 style={{ fontWeight: "700", opacity: "0.4" }}>
              <h1>SALES ENQUIRY</h1>
            </h4>
          </div>
          <FormCluster data={SalesEnquiry} />
        </div>
      )
    case "Spacer":
      return (
        <div
          style={
            object.spacerHeight
              ? { padding: object.spacerHeight + "rem 0 " }
              : { padding: "7rem 0" }
          }
        />
      )
    default:
      return <p>{console.log(object)}</p>
  }
}

const ContentfulMedia = ({ object }) => {
  switch (object.type) {
    case "Hero":
      return (
        <Banner sub fluid={object.images ? object.images[0].fluid : false}>
          <div
            className="content"
            style={{
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
            }}
          >
            <h1 style={{ textAlign: "left", color: "#fff" }}>{object.title}</h1>
            <hr
              style={{
                border: "2px solid #fff",
                maxWidth: "320px",
                width: "80%",
                margin: "0",
              }}
            />
            <p style={{ textAlign: "left", color: "#fff" }}>
              {object.description}
            </p>
          </div>
        </Banner>
      )
    case "Ads":
      return (
        <div className="constraint">
          {object.images ? (
            object.slug ? (
              <a href={object.slug} target="_blank">
                <Img
                  fluid={object.images[0].fluid}
                  style={{
                    maxWidth: "728px",
                    overflow: "hidden",
                    margin: "1rem auto",
                  }}
                />
              </a>
            ) : (
              <Img
                fluid={object.images[0].fluid}
                style={{
                  maxWidth: "728px",
                  overflow: "hidden",
                  margin: "1rem auto",
                }}
              />
            )
          ) : object.advertisements ? (
            <div style={{ maxWidth: "728px", margin: "1rem auto" }}>
              <Advertisement
                advertisements={object.advertisements}
                advertisementMobile={object.advertisementMobile}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      )
    case "Image Gallery":
      return (
        <ImageGallery
          data={object.images}
          useLightbox={object.toggleLightbox}
        />
      )
    case "Seven Gallery":
      return <SevenGallery data={object.images} />
    case "Video Gallery":
      const hosted = object.videos
        ? object.videos.map(video => video.file.url)
        : []
      const thirdParty = object.hostedVideoLinks ? object.hostedVideoLinks : []
      const concat = hosted.concat(thirdParty)
      return <VideoGallery data={concat} />
    default:
      return <p>{console.log(object)}</p>
  }
}

const Standardstyle = styled.div`
  text-align: left;
  display: ${props => (props.center ? "inline-block" : "block")};
  h1,
  h2,
  h4,
  h5,
  h6 {
    text-align: center;
    color: ${Settings.primaryColor};
  }
  h4 {
    font-size: 1.2rem;
    margin: 0 0 3rem;
  }
  h3 {
    color: ${Settings.primaryColor};
  }
  h5 {
    font-size: 1rem;
    > b {
      color: ${Settings.greyColor};
      font-size: 1.5rem;
    }
  }
  padding: 1rem 0;
`

const ContentfulContent = ({ object }) => {
  switch (object.type) {
    case "Standard":
      return (
        <div
          style={{
            background: object.background,
            padding: object.background ? "2rem 0" : "0",
          }}
        >
          <div className="constraint">
            <Standardstyle>
              {documentToReactComponents(object.content.json)}
            </Standardstyle>
          </div>
        </div>
      )
    case "Standard Equalize":
      return (
        <div
          style={{
            background: object.background,
            padding: object.background ? "2rem 0" : "0",
          }}
        >
          <div className="constraint" style={{ textAlign: "center" }}>
            <Standardstyle center>
              {documentToReactComponents(object.content.json)}
            </Standardstyle>
          </div>
        </div>
      )
    default:
      return <p>{console.log(object)}</p>
  }
}

const ContentfulBreaks = ({ object, slug }) => {
  switch (object.type) {
    case "Google Maps":
      return (
        <div className="constraint">
          <iframe
            src={object.slug}
            width="100%"
            height="450"
            frameborder="0"
            style={{ border: "0" }}
            allowfullscreen
          ></iframe>
        </div>
      )
    case "Video":
      return (
        <Break video>
          {object.content ? (
            <div>
              <div style={{ padding: "0 2rem", color: Settings.primaryColor }}>
                {documentToReactComponents(object.content.json)}
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="videoPlayer">
            <ReactPlayer url={object.slug} controls />
          </div>
        </Break>
      )
    case "Venue":
      return (
        <Break venue>
          <Grid>
            <div className="venue">
              <div className="venueTitle">
                <div style={{ margin: "0 1rem" }}>
                  <p>VENUE</p>
                </div>
              </div>
              {object.content ? (
                <div>
                  <div style={{ padding: "0 2rem" }}>
                    {documentToReactComponents(object.content.json)}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <div style={{ textAlign: "center" }}>
              {object.linked
                ? object.linked.map((link, i) => (
                    <ButtonLink
                      slug={link.slug}
                      key={i}
                      text={"GETTING THERE"}
                    />
                  ))
                : ""}
            </div>
          </Grid>
        </Break>
      )
    case "Related":
      return (
        <Break>
          {object.content ? (
            <div style={{ flex: "1 1 35%" }}>
              <Standardstyle>
                {documentToReactComponents(object.content.json)}
              </Standardstyle>
            </div>
          ) : (
            ""
          )}
          <div style={{ flex: "1 1 65%" }}>
            <Grid>
              {object.linked
                ? object.linked.map((link, i) => (
                    <div
                      className="one-resp"
                      style={{ textAlign: "center", padding: "1rem 0" }}
                    >
                      <ButtonLink
                        slug={link.slug}
                        key={i}
                        text={link.shortName ? link.shortName : link.title}
                      />
                    </div>
                  ))
                : ""}
            </Grid>
          </div>
        </Break>
      )
    case "Tabs":
      return (
        <Tab>
          <Grid columns={2}>
            {object.linked
              ? object.linked.map((link, i) => (
                  <div
                    key={i}
                    className={link.slug === slug ? "active link" : "link"}
                  >
                    <Link to={link.slug}>{link.title}</Link>
                  </div>
                ))
              : ""}
          </Grid>
        </Tab>
      )
    case "Buttons":
      return (
        <ButtonStyle>
          <div
            className="constraint"
            style={{
              maxWidth: "640px",
              textAlign: "center",
              padding: "2rem 0",
            }}
          >
            <Grid unstack>
              {object.linked
                ? object.linked.map((link, i) => (
                    <div>
                      <ButtonLink
                        slug={link.slug}
                        text={link.shortName ? link.shortName : link.title}
                        key={i}
                        type="solid"
                      />
                    </div>
                  ))
                : ""}
            </Grid>
          </div>
        </ButtonStyle>
      )
    default:
      return <p>{console.log(object)}</p>
  }
}

const ButtonStyle = styled.div`
  a {
    text-transform: uppercase;
  }
  > div {
    > div {
      align-items: stretch;
      > div {
        position: relative;
        > a {
          height: 100%;
          > button {
            height: 100%;
          }
        }
      }
    }
  }
`

const Scrollbar = styled.div`
  max-width: 640px;
  > div {
    align-items: flex-start;
    > div:last-of-type {
      p {
        padding-left: 1rem;
      }
    }
  }
  .scrollArea {
    overflow-y: scroll;
    max-height: 250px;
    ::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
    }
    ::-webkit-scrollbar-track {
      background: none;
      width: 2px;
      background-image: url(${Texture});
      background-repeat: repeat-y;
      background-size: contain;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      transform: scale(1.1);
      background-color: ${Settings.secondaryColor};
      -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    }
  }
  .selected {
    color: ${Settings.primaryColor};
    font-weight: 700;
  }
  h4 {
    cursor: pointer;
  }
`

const Tablestyle = styled.div`
  table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    tr {
      text-align: center;
    }
    th {
      background: ${Settings.primaryColor};
      color: #fff;
      font-weight: 700;
      font-size: 1.2rem;
    }
    td {
      background: #d4d4d4;
      border: 2px solid #fff;
    }
    th,
    td {
      padding: 5px;
    }
    .footer {
      background: ${Settings.secondaryColor};
      font-weight: 700;
      border: 0;
      color: #fff;
    }
  }
`

const FourCard = styled.div`
  position: relative;
  .smallCard {
    .gatsby-image-wrapper {
      height: 128px important;
      width: 128px !important;
      margin: 0 auto;
    }
    > div {
      margin: 1rem;
      text-align: center;
      padding: 1rem;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
      h4 {
        color: ${Settings.primaryColor};
        text-transform: uppercase;
      }
      a {
        color: ${Settings.secondaryColor};
      }
      h4,
      a {
        font-weight: 700;
        text-decoration: none;
      }
    }
  }
`

const StatisticOverride = styled.div`
  position: relative;
  .col:first-of-type {
  }
`

const Timeline = styled.div`
  position: relative;
  h6 {
    color: ${Settings.primaryColor};
    margin-bottom: 0;
  }
  > div {
    align-items: stretch;
    > div:first-of-type {
      border-right: 4px solid ${Settings.secondaryColor};
      flex: 0 0 10%;
      width: 10%;
      text-align: right;
    }
    > div {
      padding: 0 2rem;
    }
  }
`

const Liststyle = styled.div`
  position: relative;
  h3 {
    font-size: 1.5rem;
    font-weight: 700;
    color: ${Settings.primaryColor};
    text-transform: uppercase;
  }

  .nest,
  .row {
    transform: scaleY(0);
    height: 0;
    transition: all 225ms ease-in-out;
    transform-origin: top center;
    font-size: 0.9rem;
  }
  .active.nest,
  .row.collapse {
    transform: scaleY(1);
    height: auto;
  }

  .title {
    cursor: pointer;
    font-weight: 700;
    opacity: 0.4;
  }

  .title.selected {
    color: ${Settings.secondaryColor};
    opacity: 1;
  }
`

const ContentfulPattern = ({
  object,
  toggle,
  selected,
  toggleLightbox,
  init,
  setInit,
  setSelected,
  setSelectedDropdown,
  toggleDropdown,
  dropdownState,
  selectedAdditional,
  setSelectedAdditional,
  dropdownSelected,
}) => {
  switch (object.type) {
    case "Speakers":
      return (
        <TeamFlexi
          data={object}
          selected={selected}
          toggle={toggle}
          setSelected={setSelected}
          togglePopup={toggleLightbox}
        />
      )
    case "List":
      return (
        <Liststyle>
          <div className="constraint">
            <Grid unstack>
              <div
                onClick={() => toggleLightbox()}
                style={{ cursor: "pointer" }}
              >
                <h3>{object.title}</h3>
              </div>
              <div
                style={{ textAlign: "right", cursor: "pointer" }}
                onClick={() => toggleLightbox()}
              >
                <h3>{!toggle ? "+" : "-"}</h3>
              </div>
            </Grid>
            <div
              className={toggle ? "collapse row constraint" : "row constraint"}
            >
              {object.nestedContent.map((nest, i) => (
                <div key={i}>
                  <h4
                    onClick={() => setSelected(i)}
                    className={selected === i ? "selected title" : "title"}
                  >
                    {"> " + nest.title}
                  </h4>
                  <div className={selected === i ? "active nest" : "nest"}>
                    {documentToReactComponents(nest.content.json)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Liststyle>
      )
    case "Timeline":
      return (
        <div className="constraint">
          <Timeline>
            {object.nestedContent.map((obj, i) => (
              <Grid columns={2} unstack>
                <div>
                  <h6>
                    <b>{obj.title}</b>
                  </h6>
                </div>
                <div>{documentToReactComponents(obj.content.json)}</div>
              </Grid>
            ))}
          </Timeline>
        </div>
      )
    case "Four Column Cards":
      return (
        <FourCard>
          <div className="constraint">
            <Grid columns={4} nostretch>
              {object.nestedContent.map((nested, i) => (
                <div key={i} className="smallCard">
                  <div>
                    <Img fluid={nested.image.fluid} />
                    {nested.title ? <h4>{nested.title}</h4> : ""}
                    {nested.content
                      ? documentToReactComponents(nested.content.json)
                      : ""}
                    {nested.accordionText ? (
                      <a onClick={() => setSelected(i)}>Learn More</a>
                    ) : nested.slug ? (
                      /^(http|https):/.test(nested.slug) === true ? (
                        <a href={nested.slug} target="_blank">
                          Learn More
                        </a>
                      ) : (
                        <Link to={nested.slug}>Learn More</Link>
                      )
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ))}
            </Grid>
            {object.nestedContent[selected].accordionText ? (
              <div
                className="accordion"
                style={{
                  borderTop: "1px solid rgba(88, 88, 88, 0.3)",
                  borderBottom: "1px solid rgba(88, 88, 88, 0.3)",
                  margin: "12px 0",
                }}
              >
                {documentToReactComponents(
                  object.nestedContent[selected].accordionText.json
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        </FourCard>
      )
    case "Table":
      return (
        <Tablestyle className="constraint">
          <table>
            {object.nestedContent.map((nestedObject, k) => {
              return nestedObject.rowType === "Header" ? (
                <tr key={k}>
                  {nestedObject.tableCells.map((cell, i) => (
                    <th key={i} colspan={cell.columnSpan ? cell.columnSpan : 1}>
                      {cell.title}
                    </th>
                  ))}
                </tr>
              ) : nestedObject.rowType === "Footer" ? (
                <tr key={k}>
                  {nestedObject.tableCells.map((cell, i) => (
                    <td
                      className="footer"
                      key={i}
                      colspan={cell.columnSpan ? cell.columnSpan : 1}
                    >
                      {cell.title}
                    </td>
                  ))}
                </tr>
              ) : nestedObject.rowType == "Double Row" ? (
                <>
                  <tr>
                    {nestedObject.tableCells.map((cell, i) => {
                      return i % 2 === 0 ? (
                        <td
                          key={i}
                          colspan={cell.columnSpan ? cell.columnSpan : 1}
                          rowspan={i === 0 ? 2 : 1}
                        >
                          {cell.title}
                        </td>
                      ) : (
                        ""
                      )
                    })}
                  </tr>
                  <tr>
                    {nestedObject.tableCells.map((cell, i) => {
                      return i % 2 !== 0 ? (
                        <td
                          key={i}
                          colspan={cell.columnSpan ? cell.columnSpan : 1}
                          rowspan={i === 0 ? 2 : 1}
                        >
                          {cell.title}
                        </td>
                      ) : (
                        ""
                      )
                    })}
                  </tr>
                </>
              ) : (
                <tr key={k}>
                  {nestedObject.tableCells.map((cell, i) => (
                    <td key={i} colspan={cell.columnSpan ? cell.columnSpan : 1}>
                      {cell.title}
                    </td>
                  ))}
                </tr>
              )
            })}
          </table>
        </Tablestyle>
      )
    case "Slider":
      return (
        <Scrollbar className="constraint">
          <Grid columns={2} unstack>
            <div className="scrollArea">
              {object.nestedContent
                ? object.nestedContent.map((nest, i) => (
                    <h4
                      className={selected === i ? "selected" : ""}
                      onClick={() => setSelected(i)}
                    >
                      {nest.title}
                    </h4>
                  ))
                : ""}
            </div>
            <div>
              {object.nestedContent[selected].content
                ? documentToReactComponents(
                    object.nestedContent[selected].content.json
                  )
                : ""}
            </div>
          </Grid>
        </Scrollbar>
      )
    case "Paired":
      return (
        <Paired push={selectedAdditional} background={object.background}>
          <div>
            {object.content
              ? documentToReactComponents(object.content.json)
              : ""}
            <div>
              {object.nestedContent
                ? object.nestedContent.map((nested, i) => (
                    <div key={i}>
                      <ul
                        className={
                          i === dropdownSelected
                            ? "dropdown active"
                            : "dropdown"
                        }
                      >
                        <h6
                          onClick={() =>
                            setSelectedDropdown(
                              i !== dropdownSelected ? i : 900
                            )
                          }
                        >
                          {nested.title}
                        </h6>
                        <li>
                          {nested.content
                            ? documentToReactComponents(nested.content.json)
                            : ""}
                        </li>
                      </ul>
                    </div>
                  ))
                : ""}
            </div>
          </div>
          <div>
            <Grid>
              {object.images ? (
                <div
                  onClick={() => {
                    setSelected(0)
                    toggleLightbox()
                  }}
                >
                  <Img
                    fluid={object.images[selected].fluid}
                    style={{ maxHeight: "360px" }}
                  />
                </div>
              ) : (
                ""
              )}
            </Grid>
            {object.images ? (
              <div className="carousel">
                <b
                  onClick={() =>
                    setSelectedAdditional(
                      selectedAdditional > 0 ? selectedAdditional - 1 : ""
                    )
                  }
                  className={selectedAdditional !== 0 ? "show arrow" : "arrow"}
                >
                  {"<"}
                </b>
                <b
                  onClick={() =>
                    setSelectedAdditional(
                      selectedAdditional <= object.images.length / 3
                        ? selectedAdditional + 1
                        : ""
                    )
                  }
                  className={
                    Math.ceil(object.images.length / 3) <=
                    selectedAdditional + 1
                      ? "arrow"
                      : "show arrow"
                  }
                >
                  {">"}
                </b>
                {object.images.length > 1 ? (
                  <div className="inner">
                    {object.images
                      ? object.images.map((image, i) => (
                          <div
                            className={
                              (i + 1) % 3 === 2 ? "image middle" : "image"
                            }
                            onClick={() => {
                              setSelected(i)
                              toggleLightbox()
                            }}
                          >
                            <Img fluid={image.fluid} />
                          </div>
                        ))
                      : ""}
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        </Paired>
      )
    case "Paired Simple":
      return (
        <Paired push={selectedAdditional}>
          <div>
            {object.content
              ? documentToReactComponents(object.content.json)
              : ""}
            <div>
              {object.nestedContent
                ? object.nestedContent.map((nested, i) => (
                    <div key={i}>
                      <ul
                        className={
                          i === dropdownSelected
                            ? "dropdown active"
                            : "dropdown"
                        }
                      >
                        <h6
                          onClick={() =>
                            setSelectedDropdown(
                              i !== dropdownSelected ? i : 900
                            )
                          }
                        >
                          {nested.title}
                        </h6>
                        <li>
                          {nested.content
                            ? documentToReactComponents(nested.content.json)
                            : ""}
                        </li>
                      </ul>
                    </div>
                  ))
                : ""}
            </div>
          </div>
          <div>
            {object.images
              ? object.images.map((image, i) => (
                  <div key={i} style={{ marginBottom: "1.5rem" }}>
                    <Img fluid={image.fluid} />
                  </div>
                ))
              : ""}
          </div>
        </Paired>
      )
    case "Paired Double":
      return (
        <PairedDoubleRepeat>
          {object.nestedContent.map((obj, i) => (
            <Grid columns={2} key={i}>
              <div>{obj.image ? <Img fluid={obj.image.fluid} /> : ""}</div>
              <div>
                {obj.content ? documentToReactComponents(obj.content.json) : ""}
              </div>
            </Grid>
          ))}
        </PairedDoubleRepeat>
      )
    case "Full Cards":
      return (
        <div
          className="constraint"
          style={{
            paddingBottom: object.nestedContent.length > 4 ? "3rem" : "",
          }}
        >
          <Carousel slide={4} stackable>
            {object.nestedContent.map((nested, i) => (
              <div key={i}>
                <FullCard object={nested} />
              </div>
            ))}
          </Carousel>
        </div>
      )
    case "Full Cards with Popup":
      return (
        <div className="constraint">
          <Grid>
            {object.nestedContent.map((nested, i) => (
              <div key={i}>
                <FullCardWithPopup
                  object={nested}
                  selected={selected}
                  toggle={toggle}
                  setSelected={setSelected}
                  togglePopup={toggleLightbox}
                  thisCard={i}
                />
              </div>
            ))}
          </Grid>
        </div>
      )
    case "Flat Card":
      return (
        <ImageWithLink>
          <div className="constraint">
            <Grid>
              {object.nestedContent.map((obj, i) => (
                <Flatcard
                  fluid={obj.image.fluid}
                  json={obj.content.json}
                  slug={obj.slug}
                  key={i}
                />
              ))}
            </Grid>
          </div>
        </ImageWithLink>
      )
    case "Numbered":
      return (
        <Numbered>
          <div>
            <div className="title">
              {object.content
                ? documentToReactComponents(object.content.json)
                : ""}
            </div>
            <div className="flex">
              {object.nestedContent
                ? object.nestedContent.map((nested, i) => (
                    <div key={i}>
                      {documentToReactComponents(nested.content.json)}
                      <p className="ident"> {i + 1}</p>
                    </div>
                  ))
                : ""}
            </div>
          </div>
        </Numbered>
      )
    case "Logo with description":
      return (
        <LogoDescription>
          <div className="constraint" style={{ position: "relative" }}>
            <Grid columns={4}>
              {object.nestedContent
                ? object.nestedContent.map((nested, i) => (
                    <div onClick={() => setInit(true)} className="two-resp">
                      <PartnerDescription
                        key={i}
                        partner={nested}
                        selected={selected}
                        objectId={i}
                        callback={setSelected}
                      />
                    </div>
                  ))
                : ""}
            </Grid>
            {object.nestedContent[selected].content && init ? (
              <PartnerText
                text={object.nestedContent[selected].content.json}
                title={object.nestedContent[selected].title}
              />
            ) : (
              ""
            )}
          </div>
        </LogoDescription>
      )
    case "Logo":
      return (
        <LogoDescription>
          <div className="constraint" style={{ position: "relative" }}>
            <Grid>
              {object.nestedContent
                ? object.nestedContent.map((nested, i) => (
                    <div className="two-resp">
                      <PartnerNoDescription
                        key={i}
                        partner={nested}
                        selected={selected}
                        objectId={i}
                        callback={setSelected}
                      />
                    </div>
                  ))
                : ""}
            </Grid>
          </div>
        </LogoDescription>
      )
    case "Statistics":
      return (
        <ThreeColumns
          className="constraint"
          image={object.nestedContent[0].image ? true : false}
        >
          <StatisticOverride>
            <Grid>
              <div className="col">
                <div style={{ margin: "2rem" }}>
                  {object.nestedContent[0].image ? (
                    <img
                      src={object.nestedContent[0].image.fluid.src}
                      style={{ maxWidth: "128px", margin: "0 auto" }}
                    />
                  ) : (
                    ""
                  )}
                  {object.nestedContent[0].content
                    ? documentToReactComponents(
                        object.nestedContent[0].content.json
                      )
                    : ""}
                </div>
              </div>
              <div className="col">
                <div style={{ margin: "2rem" }}>
                  <Grid columns={2} unstack>
                    {object.nestedContent[1].image ? (
                      <div>
                        <img
                          src={object.nestedContent[1].image.fluid.src}
                          style={{ maxWidth: "128px", margin: "0 auto" }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {object.nestedContent[1].content ? (
                      <div>
                        {documentToReactComponents(
                          object.nestedContent[1].content.json
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </Grid>
                </div>
                <div style={{ margin: "2rem" }}>
                  <Grid columns={2} unstack>
                    {object.nestedContent[2].image ? (
                      <div>
                        <img
                          src={object.nestedContent[2].image.fluid.src}
                          style={{ maxWidth: "128px", margin: "0 auto" }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {object.nestedContent[2].content ? (
                      <div>
                        {documentToReactComponents(
                          object.nestedContent[2].content.json
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </Grid>
                </div>
              </div>
              <div className="col">
                <div style={{ margin: "2rem" }}>
                  <Grid columns={2} unstack>
                    {object.nestedContent[3].image ? (
                      <div>
                        <img
                          src={object.nestedContent[3].image.fluid.src}
                          style={{ maxWidth: "128px", margin: "0 auto" }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {object.nestedContent[3].content ? (
                      <div>
                        {documentToReactComponents(
                          object.nestedContent[3].content.json
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </Grid>
                </div>
                <div style={{ margin: "2rem" }}>
                  <Grid columns={2} unstack>
                    {object.nestedContent[4].image ? (
                      <div>
                        <img
                          src={object.nestedContent[4].image.fluid.src}
                          style={{ maxWidth: "128px", margin: "0 auto" }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {object.nestedContent[4].content ? (
                      <div>
                        {documentToReactComponents(
                          object.nestedContent[4].content.json
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </Grid>
                </div>
              </div>
            </Grid>
          </StatisticOverride>
        </ThreeColumns>
      )
    case "Three Column":
      return (
        <div
          style={{ background: object.background ? object.background : "none" }}
        >
          <ThreeColumns
            className="constraint"
            image={object.nestedContent[0].image ? true : false}
          >
            <Grid>
              {object.nestedContent.map((nested, i) => (
                <div key={i}>
                  <div style={{ margin: "2rem" }}>
                    {nested.image ? (
                      <img
                        src={nested.image.fluid.src}
                        style={{ maxWidth: "128px", margin: "0 auto" }}
                      />
                    ) : (
                      ""
                    )}
                    {nested.content
                      ? documentToReactComponents(nested.content.json)
                      : ""}
                  </div>
                </div>
              ))}
            </Grid>
          </ThreeColumns>
        </div>
      )
    case "Three Column Halves":
      return (
        <div
          style={{ background: object.background ? object.background : "none" }}
        >
          <ThreeColumns
            className="constraint"
            image={object.nestedContent[0].image ? true : false}
          >
            <Grid half>
              {object.nestedContent.map((nested, i) => (
                <div key={i}>
                  <div style={{ margin: "2rem" }}>
                    {nested.image ? (
                      <img
                        src={nested.image.fluid.src}
                        style={{ maxWidth: "128px", margin: "0 auto" }}
                      />
                    ) : (
                      ""
                    )}
                    {nested.content
                      ? documentToReactComponents(nested.content.json)
                      : ""}
                  </div>
                </div>
              ))}
            </Grid>
          </ThreeColumns>
        </div>
      )
    case "Four Column":
      return (
        <ThreeColumns className="constraint">
          <Grid columns={4}>
            {object.nestedContent
              ? object.nestedContent.map((nested, i) => (
                  <div key={i}>
                    <div style={{ margin: "2rem" }}>
                      {nested.image ? (
                        <Img
                          fluid={nested.image.fluid}
                          style={{ maxWidth: "128px", margin: "0 auto" }}
                        />
                      ) : (
                        ""
                      )}
                      {nested.content
                        ? documentToReactComponents(nested.content.json)
                        : ""}
                    </div>
                  </div>
                ))
              : ""}
          </Grid>
        </ThreeColumns>
      )
    case "Five Column":
      return (
        <ThreeColumns className="constraint">
          <Grid columns={5}>
            {object.nestedContent
              ? object.nestedContent.map((nested, i) => (
                  <div
                    key={i}
                    className="three-resp"
                    style={{ flex: "0 0 19%" }}
                  >
                    <div style={{ margin: "2rem" }}>
                      {nested.image ? (
                        nested.slug ? (
                          <a href={nested.slug} target="_blank">
                            <Img
                              fluid={nested.image.fluid}
                              style={{ maxWidth: "128px", margin: "0 auto" }}
                            />
                          </a>
                        ) : (
                          <Img
                            fluid={nested.image.fluid}
                            style={{ maxWidth: "128px", margin: "0 auto" }}
                          />
                        )
                      ) : (
                        ""
                      )}
                      {nested.content
                        ? documentToReactComponents(nested.content.json)
                        : ""}
                    </div>
                  </div>
                ))
              : ""}
          </Grid>
        </ThreeColumns>
      )
    case "Quotes":
      return <Quotes data={object} grey />
    case "Featured News":
      return (
        <PairedRepeat newsbyte>
          {object.nestedContent
            ? object.nestedContent.map((nested, i) => (
                <div key={i}>
                  <div>
                    {nested.banner ? <Img fluid={nested.banner.fluid} /> : ""}
                  </div>
                  <div>
                    <p>
                      {nested.newsbyte_category ? (
                        <b style={{ color: Settings.primaryColor }}>
                          {nested.newsbyte_category
                            ? nested.newsbyte_category[0].title
                            : ""}
                        </b>
                      ) : (
                        ""
                      )}{" "}
                      | {nested.publishedDate}
                    </p>
                    <h6 onClick={() => setSelectedDropdown(i)}>
                      {nested.title}
                    </h6>
                    {nested.shortDescription
                      ? documentToReactComponents(nested.shortDescription.json)
                      : ""}
                    <Link
                      to={
                        "/newsbyte/" +
                        nested.title
                          .replace(/\s+/g, "-")
                          .replace(/[!@#$%^&*?]/g, "")
                          .toLowerCase()
                      }
                    >
                      Read more >
                    </Link>
                  </div>
                </div>
              ))
            : ""}
        </PairedRepeat>
      )
    default:
      return <p>{console.log(object)}</p>
  }
}

const EnhancedContentfulPattern = withLightbox(ContentfulPattern)

export const fragments = graphql`
  fragment pageFragment on ContentfulPage {
    id
    title
    slug
    content {
      __typename
      ... on ContentfulContent {
        id
        type
        background
        content {
          json
        }
      }
      ... on ContentfulPattern {
        id
        type
        title
        background
        nestedContent {
          ... on ContentfulTableRow {
            rowType
            tableCells {
              title
              columnSpan
            }
          }
          ... on ContentfulPopupContent {
            id
            content {
              json
            }
            images {
              fluid {
                ...GatsbyContentfulFluid
                src
              }
            }
            shortDescription {
              json
            }
            content {
              json
            }
            title
          }
          ... on ContentfulNestedContent {
            id
            content {
              json
            }
            image {
              fluid {
                ...GatsbyContentfulFluid
                src
              }
            }
            title
            slug
            accordionText {
              json
            }
            type
          }
          ... on ContentfulNewsbyte {
            id
            title
            newsbyte_category {
              title
            }
            banner {
              fluid {
                ...GatsbyContentfulFluid
              }
            }
            shortDescription: description {
              json
            }
            publishedDate(formatString: "DD MMMM YYYY")
          }
          ... on ContentfulPartnersAndSponsors {
            id
            content {
              json
            }
            slug
            description
            image {
              fluid {
                ...GatsbyContentfulFluid
              }
            }
            title
          }
        }
        images {
          fluid {
            ...GatsbyContentfulFluid
          }
        }
        content {
          json
        }
      }
      ... on ContentfulBreaks {
        id
        title
        type
        content {
          json
        }
        linked {
          slug
          title
          shortName
        }
        slug
      }
      ... on ContentfulSpecials {
        id
        type
        spacerHeight
        reference {
          files {
            file {
              url
              fileName
            }
            description
          }
        }
      }
      ... on ContentfulMedia {
        id
        type
        title
        slug
        hostedVideoLinks
        description
        toggleLightbox
        advertisements {
          id
          slug
          title
          image {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
        advertisementMobile {
          id
          slug
          title
          image {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
        images {
          fluid(maxWidth: 1920) {
            ...GatsbyContentfulFluid
          }
        }
      }
    }
  }
`

export const query = graphql`
  query($id: String!) {
    contentfulPage(id: { eq: $id }) {
      ...pageFragment
      content {
        ... on ContentfulTabGroup {
          title
          types
          tabs {
            ...pageFragment
          }
        }
      }
    }
  }
`

export default pageTemplate
